import { req } from "./service";

const apis: Record<string, any> = {
  login: ["p", "login"],
  register: ["p", "register"],
  pwd: ["p", "login/pwd"],
};

export async function api(key: string, data = {}) {
  const item = apis[key];
  if (item === undefined) {
    return {
      status: false,
      data: "API NOT FOUND",
    };
  } else {
    return req(item[0], "/" + item[1], data);
  }
}
